import { Field } from "formik";
import { RadioButton } from "features/FolderManager/components/Questions/components/Form/SpecialButtons";
import React from "react";
import { Dropdown } from "semantic-ui-react";
import moment from "moment";
import { isMobile, isTabletOrLess } from "utils/isMobile";

const styles = {
	groupGender: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
	},
	labelGroupGender: {
		fontSize: "1em",
		fontWeight: 600,
		marginBottom: 10,
		marginTop: 5,
		marginLeft: 2,
		width: "90%",
	},
	radioGroupGender: {
		height: 30,
		width: isMobile() ? "100%" : isTabletOrLess() ? "50%" : "33%",
		display: "flex",
		flex: 1,
		flexBasis: isMobile() ? "100%" : isTabletOrLess() ? "50%" : "33%",
	},
	inputStyle: {
		width: "100%",
	},
	inputContainer: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
	},
	records: {
		position: "absolute",
		right: 0,
	},
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 4,
		left: 4,
	},
};

const errorStyle = {
	marginBottom: 10,
	color: "#dc0000",
	fontSize: "0.7em",
};

const Records = ({ records, onClick, disabled }) => (
	<Dropdown
		closeOnEscape
		closeOnChange
		icon="file alternate outline"
		direction="right"
		className="largegreenIcon"
		style={styles.records}
		disabled={disabled}
	>
		<Dropdown.Menu direction="left">
			<Dropdown.Header icon="folder outline" content="Antécédants" />
			<Dropdown.Divider />
			{records.map((r, i) => (
				<Dropdown.Item
					key={r.label + " " + r.value + i}
					description={moment(r.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						onClick(r);
					}}
					text={String(r.label)}
				/>
			))}
		</Dropdown.Menu>
	</Dropdown>
);

const RadioButtons = ({ customlabel, name, fields, setfieldvalue, records, values, touched, errors, required, prevalidfolders, disabled }) => (
	<div>
		<div style={styles.groupGender}>
			<div style={styles.labelGroupGender}>
				{customlabel}
				{required && <span style={styles.crossRequired}>*</span>}
				{records.length > 0 && (
					<Records
						records={records}
						onClick={(r) => {
							if (r.from_free_input) {
								setfieldvalue(name, "freeInput");
								setfieldvalue(name + "freeInput", r.value[0]);
							} else {
								setfieldvalue(name, r.value[0]);
							}
						}}
						disabled={disabled}
					/>
				)}
			</div>

			<div style={styles.inputContainer}>
				{fields.map((f, i) => {
					return (
						<div style={styles.radioGroupGender} key={"radio_" + name + "_" + i}>
							<Field
								customlabel={f.customlabel}
								component={RadioButton}
								name={f.name}
								onBlur={(e) => {
									if (prevalidfolders) prevalidfolders();
								}}
								values={values}
								id={f.id}
								label="choose1"
							/>
						</div>
					);
				})}
			</div>

			{errors[name] && <div style={errorStyle}>{errors[name]}</div>}
		</div>
	</div>
);

export default RadioButtons;
